// app/frontend/controllers/ranking_controller.js
import {Controller} from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
    static targets = ["list", "rankLabel", "points", "teamSelect"]

    connect() {
        this.sortable = Sortable.create(this.listTarget, {
            animation: 150,
            onEnd: this.onEnd.bind(this),
            filter: '.locked'
        })

        // Optional uniqueness enforcement flag (enable with data-unique="true" on the controller element)
        this.enforceUnique = (this.element.dataset.unique === "true")

        // Capture the values of any options that are initially disabled so they
        // always remain disabled regardless of user interactions.
        this.initiallyDisabledValues = new Set()
        if (this.teamSelectTargets && this.teamSelectTargets.length > 0) {
            this.teamSelectTargets.forEach((selectEl) => {
                const options = selectEl.options
                for (let i = 0; i < options.length; i += 1) {
                    const opt = options[i]
                    if (opt && opt.disabled === true && opt.value) {
                        this.initiallyDisabledValues.add(opt.value)
                    }
                }
            })
        }

        this.rankLabels = this.rankLabelTargets.map(tgt => {
            // console.log('tgt', tgt.value, tgt)
            return tgt.value;
        });

        this.points = this.pointsTargets.map(tgt => {
            // console.log('tgt', tgt.value, tgt)
            return tgt.value;
        });
        console.log("rankLabels", this.rankLabelTargets, this.points);

        if (this.enforceUnique) {
            this.syncDisabledOptions();
        }
    }

    onEnd(event) {
        this.updateRankLabels()
    }

    updateRankLabels() {
        this.rankLabelTargets.forEach((tgt, i) => {
            tgt.value = this.rankLabels[i];

            tgt.closest('.ranking-item').querySelector('.rank-label').textContent = this.rankLabels[i];
        });
        this.pointsTargets.forEach((tgt, i) => {
            tgt.value = this.points[i];

            tgt.closest('.ranking-item').querySelector('.points').textContent = this.points[i];
        });
    }

    /**
     * Handle changes in team selections. If uniqueness is enforced, clear any
     * other select that contains the same value and animate the cleared item.
     */
    teamSelectChanged(event) {
        if (!this.enforceUnique) return;

        const currentSelect = event.target;
        const value = currentSelect.value;

        if (value) {
            // Find other selects with the same value and clear them
            this.teamSelectTargets.forEach((selectEl) => {
                if (selectEl === currentSelect) return;
                if (selectEl.value === value) {
                    // Clear the duplicate selection
                    selectEl.value = "";

                    // Add a temporary CSS class to animate the cleared item
                    const item = selectEl.closest(".ranking-item");
                    if (item) {
                        item.classList.remove("ranking-item--cleared");
                        // force reflow to restart animation if needed
                        // eslint-disable-next-line no-unused-expressions
                        item.offsetWidth;
                        item.classList.add("ranking-item--cleared");
                        // Remove the class after animation ends
                        const removeClass = () => {
                            item.classList.remove("ranking-item--cleared");
                            item.removeEventListener("animationend", removeClass);
                        };
                        item.addEventListener("animationend", removeClass);
                    }

                    // Trigger a change event in case any listeners depend on it
                    const evt = new Event("change", { bubbles: true });
                    selectEl.dispatchEvent(evt);
                }
            });
        }

        // Always update disabled/enabled options after any change
        this.syncDisabledOptions();
    }

    /**
     * Disable options already selected in other dropdowns and re-enable them
     * when they are no longer selected. Keeps the currently selected option
     * enabled in its own select so the user can keep or change it.
     */
    syncDisabledOptions() {
        if (!this.teamSelectTargets || this.teamSelectTargets.length === 0) return;

        const selectedValues = new Set();
        this.teamSelectTargets.forEach((sel) => {
            if (sel.value) selectedValues.add(sel.value);
        });

        this.teamSelectTargets.forEach((selectEl) => {
            const currentValue = selectEl.value;
            const options = selectEl.options;
            for (let i = 0; i < options.length; i += 1) {
                const opt = options[i];
                // Never disable blank option
                if (!opt.value) {
                    opt.disabled = false;
                    continue;
                }

                // Respect options that started disabled: they must remain disabled
                const initiallyDisabled = this.initiallyDisabledValues && this.initiallyDisabledValues.has(opt.value);
                if (initiallyDisabled) {
                    opt.disabled = true;
                    continue;
                }

                if (selectedValues.has(opt.value) && opt.value !== currentValue) {
                    opt.disabled = true;
                } else {
                    opt.disabled = false;
                }
            }
        });
    }
}
